export default __webpack_public_path__ + "static/media/dropverse_tile-mobile.png.webp";